
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_l4w59_34",
  "checkbox-control": "awsui_checkbox-control_k2y2q_l4w59_67",
  "outline": "awsui_outline_k2y2q_l4w59_81"
};
  